// extracted by mini-css-extract-plugin
export default {"root":"FeedsPage_root__6BaPU"};